import APIClient from './axios.util';

const adminApi = {
    // ── Demo Catalog Management ──────────────────────────────────────────────

    // GET /api/demos/ — paginated {success, data:{items,total,page,limit,pages}}
    getCatalog: (page = 1, limit = 10) => APIClient.get('/demos/', { params: { page, limit } }),

    // POST /api/demos/catalog — body: {app, id, title, url, description, is_active}
    createDemo: (payload) => APIClient.post('/demos/catalog', payload),

    // PUT /api/demos/catalog/:app/:demo_id — body: {title, url, description, is_active}
    updateDemo: (app, id, payload) =>
        APIClient.put(`/demos/catalog/${encodeURIComponent(app)}/${id}`, payload),

    // DELETE /api/demos/catalog/:app/:demo_id — hard delete
    deleteDemo: (app, id) =>
        APIClient.delete(`/demos/catalog/${encodeURIComponent(app)}/${id}`),

    // ── Access Request Management ────────────────────────────────────────────

    // GET /api/admin/requests — paginated; status: 'pending'|'reviewed' (omit for all)
    getRequests: (page = 1, limit = 10, status) =>
        APIClient.get('/admin/requests', {
            params: { page, limit, ...(status && status !== 'all' && { status }) },
        }),

    // GET /api/admin/requests/:request_id — wrapped {success, data:{..., requested_demos:[{id,title,app}]}}
    getRequestDetail: (requestId) => APIClient.get(`/admin/requests/${requestId}`),

    // PUT /api/admin/requests/:request_id/review
    // body: {approved_demo_ids, rejected_demo_ids, rejection_reason, notes}
    reviewRequest: (requestId, payload) =>
        APIClient.put(`/admin/requests/${requestId}/review`, payload),

    // PUT /api/admin/requests/:request_id/access — post-review access modification
    // body: {approved_demo_ids, revoked_demo_ids, notes}
    modifyRequestAccess: (requestId, payload) =>
        APIClient.put(`/admin/requests/${requestId}/access`, payload),

    // ── User Management ──────────────────────────────────────────────────────

    // GET /api/admin/users — paginated; role: 'admin'|'user' (omit for all)
    getUsers: (page = 1, limit = 10, role) =>
        APIClient.get('/admin/users', {
            params: { page, limit, ...(role && role !== 'all' && { role }) },
        }),

    // POST /api/admin/users — body: {name, companyEmail, password, role, status, ...}
    createUser: (payload) => APIClient.post('/admin/users', payload),

    // POST /api/admin/users/import — multipart file upload
    importUsers: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return APIClient.post('/admin/users/import', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    // PUT /api/admin/users/:email — body: any subset of {name, role, status}
    updateUser: (email, payload) =>
        APIClient.put(`/admin/users/${encodeURIComponent(email)}`, payload),

    // DELETE /api/users/email/:email — soft delete (sets status to inactive)
    deleteUser: (email) =>
        APIClient.delete(`/users/email/${encodeURIComponent(email)}`),
};

export default adminApi;
